// import axios from 'axios'
import Naluri from '~/common/api/naluri'
import {
  SESSION_VALIDATE_BEGIN,
  SESSION_VALIDATE_SUCCESS,
  SESSION_VALIDATE_FAILURE,
  SESSION_VALIDATE_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function validate(token, cognito = true) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SESSION_VALIDATE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const params = {
        'authorization': 'Bearer '+token
      }

      const uri = (cognito) ? `/api/me` : `/api/user/current`
      const doRequest = Naluri.get(uri, params)

      doRequest.then(
        (res) => {
          if (!res.error) {
            if (res.role !== 'member' || res.role !== 'admin') {
              dispatch({
                type: SESSION_VALIDATE_SUCCESS,
                data: (res.user) ? res.user : res,
              });
            } else {
              const textError = 'You are not authorized to perform this action.'
              dispatch({
                type: SESSION_VALIDATE_FAILURE,
                data: { error: textError },
              });
            }
          } else {
            dispatch({
              type: SESSION_VALIDATE_FAILURE,
              data: { error: res.error },
            });
          }
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SESSION_VALIDATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissValidateError() {
  return {
    type: SESSION_VALIDATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SESSION_VALIDATE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        validatePending: true,
        validateError: null,
      };

    case SESSION_VALIDATE_SUCCESS:
      // The request is success
      return {
        ...state,
        authenticated: action.data,
        validatePending: false,
        validateError: null,
      };

    case SESSION_VALIDATE_FAILURE:
      // The request is failed
      return {
        ...state,
        validatePending: false,
        validateError: action.data.error,
        loginError: action.data.error,
      };

    case SESSION_VALIDATE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        validateError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/session/redux/validate.js